// extracted by mini-css-extract-plugin
export default {"container":"MVAfjg2sXljUCyQWpUQ0"};